<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="text" icon="el-icon-plus" size="small" plain v-if="permission.JOINS_SALES_CLOUD_SHOP_ADD"
            @click.stop="handleAdd()">新增</el-button>
          <!-- 下载通用码 -->
          <el-button type="text" icon="el-icon-download" size="small"
            v-if="permission.JOINS_SALES_CLOUD_DOWNLOAD_WATER_CODE" @click.stop=downloadCode()>下载净水报单通用码</el-button>
          <el-button size="mini" type="text" @click="openUpload()" icon="el-icon-upload">
            导入电话下载二维码
          </el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-view" size="small" plain
            @click.stop="handleDetail(scope.row, scope.index)">查看</el-button>
          <el-button type="text" icon="el-icon-edit" size="small" plain v-if="permission.JOINS_SALES_CLOUD_SHOP_EDIT"
            @click.stop="handleEdit(scope.row, scope.index)">编辑</el-button>
          <!-- <el-button type="text" icon="el-icon-download" size="small"
            v-if="permission.JOINS_SALES_CLOUD_SHOP_DOWNLOAD_WATER"
            @click.stop=downloadCode(scope.row)>净水码</el-button>
          <el-button type="text" icon="el-icon-download" size="small"
            v-if="permission.JOINS_SALES_CLOUD_SHOP_DOWNLOAD_WATER_PROOF"
            @click.stop=downloadCode1(scope.row)>防水码</el-button>
          <el-button type="text" icon="el-icon-download" size="small"
            v-if="permission.JOINS_SALES_CLOUD_SHOP_DOWNLOAD_ENGINEERING_CODE"
            @click.stop=downloadCode2(scope.row)>工程码</el-button>
            <el-button type="text" icon="el-icon-download" size="small"
            v-if="permission.JOINS_SALES_CLOUD_SHOP_DOWNLOAD_CEILING"
            @click.stop=downloadCode3(scope.row)>吊顶码</el-button> -->
            <!-- 统一报单码 -->
            <el-button type="text" icon="el-icon-download" size="small"
            @click.stop=downloadCode4(scope.row)>统一码</el-button>
        </template>
        <template slot-scope="scope" slot="provinceNameForm">
          <el-input type="input" name="title" :value="point.pname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="cityNameForm">
          <el-input type="input" name="title" :value="point.cityname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="areaNameForm">
          <el-input type="input" name="title" :value="point.adname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="provincesPoIntForm">
          <avue-map v-model="point"></avue-map>
        </template>
        <template slot-scope="scope" slot="dutyIdCardFrontImgForm">
          <el-upload :multiple="false" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList" :http-request="fnUploadFrontRequest" :show-file-list="false">
            <div v-if="'' != dutyIdCardFrontImg" class="el-upload el-upload--picture-img">
              <img :src="dutyIdCardFrontImg" style="width: 200px;" />
              <a style="margin-left: 20px" @click.stop="deleteFront(dutyIdCardFrontImg)">删除</a>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="dutyIdCardBackImgForm">
          <el-upload :multiple="false" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList" :http-request="fnUploadBackRequest" :show-file-list="false">
            <div v-if="'' != dutyIdCardBackImg" class="el-upload el-upload--picture-img">
              <img :src="dutyIdCardBackImg" style="width: 200px;" />
              <a style="margin-left: 20px" @click.stop="deleteBack(dutyIdCardBackImg)">删除</a>
            </div>

            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="businessLicenseForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList" :http-request="fnUploadBusinessRequest" :show-file-list="false">
            <div v-if="'' != businessLicense" class="el-upload el-upload--picture-img">
              <div :key="item.id" v-for="item of businessLicense">
                <img :src="item" style="width: 200px;" />
                <a style="margin-left: 20px" @click.stop="deletePic(item)">删除</a>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
      </avue-crud>
      <el-dialog title="" :visible.sync="dialogFormVisible" width="30%" :close-on-click-modal="false">
        <el-form :model="addForm">
          <el-form-item label="商户手机号" style="display:flex;justify-content: center;">
            <el-input v-model="shopAccount" placeholder="请输入商户手机号" style="width:220px;">
            </el-input>
          </el-form-item>
          <el-form-item label="商户名称" style="display:flex;justify-content: center;" v-if="!isRegister">
            <el-input disabled style="margin-left:14px;width:220px" v-model="shopName"></el-input>
          </el-form-item>
          <el-form-item label="" style="display:flex;justify-content: center;" v-if="isRegister">
            <div>
              {{ shopName }}
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="openAdd" v-if="!isRegister">确 定</el-button>
          <el-button type="primary" @click="openAdd" v-if="isRegister">注 册</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="uploadDialogVisible" title="上传商家电话下载二维码" width="30%" :close-on-click-modal="false">
      <el-form :model="uploadForm" :rules="uploadRules" ref="uploadFormRef" label-width="100px">
        <el-form-item label="用户类型" prop="clientType">
          <el-select v-model="uploadForm.type" placeholder="请选择类型">
            <el-option label="净水" value="PURE_WATER"></el-option>
            <el-option label="防水" value="WATERPROOF"></el-option>
            <el-option label="工程" value="ENGINEERING"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件">
          <el-upload class="upload-demo" ref="upload" :action="fileUrl" :limit="1" :headers="headers"
            accept=".xls,.xlsx,csv" :on-remove="handleRemoveFile" :file-list="uploadForm.fileList" :auto-upload="false">
            <el-button type="success" size="small" round>上传Excel<i
              class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx/csv文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelUpload">取消</el-button>
        <el-button type="primary" @click="handleUpload">提交</el-button>
      </div>
    </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { shopTableOption } from "@/const/salesCloud/shopOption";
import {
  v1BindingRegistryShop,
  editShop,
  delShop,
  findShopDetail,
  v1BindingList,
  approve,
  prohibit,
  v1BindingDetermine,
  v1BindingBindingShop,
  getDownloadCode,
  getRootDepartmentId,
  downloadPureWaterQrZip
} from "@/api/salesCloud/shop";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "shop",
  components: {},
  data() {
    return {
      tableOption: shopTableOption,
      fileUrl: "https://huijia.joinstech.com", //上传文件的域名地址
      showFileList: false, //文件列表是否显示,默认不显示
      headers: {
        "Content-Type": "multipart/form-data",
      },
      tableData: [],
      tableLoading: false,
      dialogFormVisible: false,
      uploadDialogVisible: false,
      uploadForm: {
        type: ''
      },
      uploadRules: {
        type: [
          { required: true, message: '请选择用户类型', trigger: 'change' },
        ],
      },
      rootDepartmentId: "",
      addForm: {},
      shopAccount: "",
      codeDialogVisible: false,
      codeImage: '',
      shopName: "",
      isRegister: false,
      resData: {},
      tabelObj: {},
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      grade: {
        box: false,
        check: []
      },
      dutyIdCardFrontImg: "",
      dutyIdCardBackImg: "",
      businessLicense: [],
      fileList: [],
      point: {}
    };
  },
  created() {
    this.handleList();
  },
  watch: {
    shopAccount(mobile) {
      console.log(mobile);
      if (mobile.length == 11) {
        let params = {};
        params.mobile = mobile;
        v1BindingDetermine(params).then(res => {
          if (res.data) {
            let data = JSON.parse(res.data);
            console.log(res);
            this.resData = data;
            this.isRegister = false;
            this.shopName = data.shopName;
          } else {
            console.log(res);
            this.isRegister = true;
            this.shopName = "当前手机号暂未注册，是否立即注册？";
          }
        });
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    openUpload() {
      this.uploadDialogVisible = true;
    },
    cancelUpload() {
      this.uploadDialogVisible = false;
      this.uploadForm = {
        file: null,
        type: ''
      };
      this.uploadForm.fileList = [];
    },
    handleRemoveFile(file) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid);
    },
    handleUpload() {
      if (!this.$refs.upload.uploadFiles[0]) {
            this.$message.error('请上传文件!');
            return;
          }
      this.$refs.uploadFormRef.validate(valid => {
        if (valid) {
          this.uploadForm.file = this.$refs.upload.uploadFiles[0].raw;
            //上传Excel文件
          this.verifyUploadFile(this.uploadForm.file, this.uploadForm.type);
          this.uploadForm = {
            type: '',
            file: null,
          };
          this.uploadForm.fileList = [];
          this.$message.success("上传成功");
          this.uploadDialogVisible = false;
        }
      });
    },
    //验证Excel文件返回文件流下载
    verifyUploadFile(file, type) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('file_name', file.name);
      formData.append('type', type);
      // console.log('formData::: ', formData);
      downloadPureWaterQrZip(formData).then((response) => {
        console.log(response);
        
        // 提取文件名
        const filename = "商家码.zip"
        // 将二进制流转为blob
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename))
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob)
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', decodeURI(filename))
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
          }
          // 挂载a标签
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL)
          this.handleList();
        }
      });
    },
    // 生成商家码并显示弹窗
    downloadCode(row) {
      if (row) {
        this.$confirm("是否确认生成'" + row.shopName + "店铺'商家码?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const data = {
              scene: this.rootDepartmentId + "," + row.id + ',' + row.shopName,
              page: "pages/waterProject/install/install",
              width: "340",
              clientType: "JOINS_MERCHANT",
            };
            getDownloadCode(data).then((response) => {
              // 提取文件名
              const filename = response.headers["content-disposition"].match(
                /filename=(.*)/
              )[1];
              console.log(filename);
              // 将二进制流转为blob
              const blob = new Blob([response.data], {
                type: "application/octet-stream",
              });
              if (typeof window.navigator.msSaveBlob !== "undefined") {
                // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                window.navigator.msSaveBlob(blob, decodeURI(filename));
              } else {
                // 创建新的URL并指向File对象或者Blob对象的地址
                const blobURL = window.URL.createObjectURL(blob);
                // 创建a标签，用于跳转至下载链接
                const tempLink = document.createElement("a");
                tempLink.style.display = "none";
                tempLink.href = blobURL;
                tempLink.setAttribute("download", decodeURI(filename));
                // 兼容：某些浏览器不支持HTML5的download属性
                if (typeof tempLink.download === "undefined") {
                  tempLink.setAttribute("target", "_blank");
                }
                // 挂载a标签
                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
                // 释放blob URL地址
                window.URL.revokeObjectURL(blobURL);
                this.handleList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消生成商家码"
            });
          });
      } else {
        this.$confirm("是否确认生成通用商家码?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const data = {
            scene: this.rootDepartmentId,
            page: "pages/waterProject/install/install",
            width: "340",
            clientType: "JOINS_MERCHANT",
          };
          getDownloadCode(data).then((response) => {
            // 提取文件名
            const filename = response.headers["content-disposition"].match(
              /filename=(.*)/
            )[1];
            console.log(filename);
            // 将二进制流转为blob
            const blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            if (typeof window.navigator.msSaveBlob !== "undefined") {
              // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(filename));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement("a");
              tempLink.style.display = "none";
              tempLink.href = blobURL;
              tempLink.setAttribute("download", decodeURI(filename));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === "undefined") {
                tempLink.setAttribute("target", "_blank");
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
              this.handleList();
            }
          });
        })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消生成通用商家码"
            });
          });
      }
    },
    // 生成防水商家码并显示弹窗
    downloadCode1(row) {
      this.$confirm("是否确认生成'" + row.shopName + "店铺'商家码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const data = {
            scene: this.rootDepartmentId + "," + row.id + ',' + row.shopName,
            page: "pages/waterProof/customer/customer",
            width: "340",
            clientType: "JOINS_MERCHANT",
          };
          getDownloadCode(data).then((response) => {
            // 提取文件名
            const filename = response.headers["content-disposition"].match(
              /filename=(.*)/
            )[1];
            console.log(filename);
            // 将二进制流转为blob
            const blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            if (typeof window.navigator.msSaveBlob !== "undefined") {
              // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(filename));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement("a");
              tempLink.style.display = "none";
              tempLink.href = blobURL;
              tempLink.setAttribute("download", decodeURI(filename));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === "undefined") {
                tempLink.setAttribute("target", "_blank");
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
              this.handleList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成商家码"
          });
        });

    },
    // 生成工程报单商家码并显示弹窗
    downloadCode2(row) {
      this.$confirm("是否确认生成'" + row.shopName + "店铺'商家码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const data = {
            scene: this.rootDepartmentId + "," + row.id + ',' + row.shopName,
            page: "pages/engineeringProject/declaration/declaration",
            width: "340",
            clientType: "JOINS_MERCHANT",
          };
          getDownloadCode(data).then((response) => {
            // 提取文件名
            const filename = response.headers["content-disposition"].match(
              /filename=(.*)/
            )[1];
            console.log(filename);
            // 将二进制流转为blob
            const blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            if (typeof window.navigator.msSaveBlob !== "undefined") {
              // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(filename));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement("a");
              tempLink.style.display = "none";
              tempLink.href = blobURL;
              tempLink.setAttribute("download", decodeURI(filename));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === "undefined") {
                tempLink.setAttribute("target", "_blank");
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
              this.handleList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成商家码"
          });
        });
    },
    //downloadCode3
    downloadCode3(row) {
      this.$confirm("是否确认生成'" + row.shopName + "店铺'商家码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
       .then(() => {
          const data = {
            scene: this.rootDepartmentId + "," + row.id + ',' + row.shopName,
            page: "pages/ceiling/customer/customer",
            width: "340",
            clientType: "JOINS_MERCHANT",
          }
          getDownloadCode(data).then((response) => {
            // 提取文件名
            const filename = response.headers["content-disposition"].match(
              /filename=(.*)/
            )[1];
            console.log(filename);
            // 将二进制流转为blob
            const blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            if (typeof window.navigator.msSaveBlob !== "undefined") {
              // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(filename));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement("a");
              tempLink.style.display = "none";
              tempLink.href = blobURL;
              tempLink.setAttribute("download", decodeURI(filename));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === "undefined") {
                tempLink.setAttribute("target", "_blank");
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
              this.handleList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成商家码"
          });
        });
    },
    // downloadCode4，pages/business-select/business-select
    downloadCode4(row) {
      this.$confirm("是否确认生成'" + row.shopName + "店铺'统一码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
       .then(() => {
          const data = {
            scene: this.rootDepartmentId + "," + row.id + ',' + row.shopName,
            page: "pages/business-select/business-select",
            width: "340",
            clientType: "JOINS_MERCHANT",
          }
          getDownloadCode(data).then((response) => {
            // 提取文件名
            const filename = response.headers["content-disposition"].match(
              /filename=(.*)/
            )[1];
            console.log(filename);
            // 将二进制流转为blob
            const blob = new Blob([response.data], {
              type: "application/octet-stream",
            });
            if (typeof window.navigator.msSaveBlob !== "undefined") {
              // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(filename));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement("a");
              tempLink.style.display = "none";
              tempLink.href = blobURL;
              tempLink.setAttribute("download", decodeURI(filename));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === "undefined") {
                tempLink.setAttribute("target", "_blank");
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
              this.handleList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成商家码"
          });
        });
    },
    // resetDialog
    resetDialog() {
      this.codeImage = '';
      this.shopName = '';
    },
    deletePic(item) {
      let index = this.businessLicense.indexOf(item);
      if (index > -1) {
        this.businessLicense.splice(index, 1);
      }
    },
    deleteBack() {
      this.dutyIdCardBackImg = "";
    },
    deleteFront() {
      this.dutyIdCardFrontImg = "";
    },
    handleProhibit() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认禁用?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          prohibit(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => { });
    },
    handleApprove(row, option) {
      let data = new Object();
      data.shopId = row.id;
      data.status = option;
      approve(data).then(response => {
        if (response.code == "200") {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
        }
      });
    },
    async fnUploadFrontRequest(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.dutyIdCardFrontImg = array[0];
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    async fnUploadBackRequest(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name);
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            console.log("上传图片：" + JSON.stringify(results.res));
            let array = results.res.requestUrls[0].split("?");
            this.dutyIdCardBackImg = array[0];
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    async fnUploadBusinessRequest(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name);
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.businessLicense.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.shopAddress = params.address;
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      console.log(page);
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      v1BindingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    handleDetail(row, index) {
      findShopDetail(row.id).then(res => {
        let data = JSON.parse(res.data);
        this.dutyIdCardFrontImg = data.dutyIdCardFrontImg;
        this.dutyIdCardBackImg = data.dutyIdCardBackImg;
        this.businessLicense = data.businessLicense;
        let location = new Object();
        location.lng = data.longitude;
        location.lat = data.latitude;
        this.point.location = location;
        this.point.pcode = data.province;
        this.point.adcode = data.city;
        this.point.adcode = data.area;
        this.point.pname = data.province;
        this.point.cityname = data.cityName;
        this.point.adname = data.areaName;
        this.$refs.crud.rowView(data, index);
      });
    },
    clean() {
      this.dutyIdCardFrontImg = "";
      this.dutyIdCardBackImg = "";
      this.businessLicense = [];
      this.point = {};
      this.shopAccount = "";
      this.shopName = "";
      this.isRegister = false;
      this.resData = {};
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.dialogFormVisible = true;
      // this.clean();
      // this.$refs.crud.rowAdd();
    },
    openAdd() {
      if (!this.isRegister) {
        v1BindingBindingShop(this.resData).then(res => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "新增绑定成功",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        });
      } else {
        this.dialogFormVisible = false;
        this.clean();
        this.$refs.crud.rowAdd();
      }
    },
    handleEdit(row, index) {
      findShopDetail(row.id).then(res => {
        let data = JSON.parse(res.data);
        this.dutyIdCardFrontImg = data.dutyIdCardFrontImg;
        this.dutyIdCardBackImg = data.dutyIdCardBackImg;
        this.businessLicense = data.businessLicense;
        let location = new Object();
        location.lng = data.longitude;
        location.lat = data.latitude;
        this.point.location = location;
        this.point.pcode = data.province;
        this.point.adcode = data.city;
        this.point.adcode = data.area;
        this.point.pname = data.province;
        this.point.cityname = data.cityName;
        this.point.adname = data.areaName;
        this.$refs.crud.rowEdit(data, index);
      });
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      v1BindingList(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        getRootDepartmentId().then(res => {
          let data = res.data;
          this.rootDepartmentId = data;
        });
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(this.point);
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pcode;
      row.city = this.point.adcode.substring(0, 4) + "00";
      row.area = this.point.adcode;
      row.dutyIdCardFrontImg = this.dutyIdCardFrontImg;
      row.dutyIdCardBackImg = this.dutyIdCardBackImg;
      row.businessLicense = this.businessLicense;
      v1BindingRegistryShop(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delShop(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => { });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pcode;
      row.city = this.point.adcode.substring(0, 4) + "00";
      row.area = this.point.adcode;
      console.log(this);
      row.dutyIdCardFrontImg = this.dutyIdCardFrontImg;
      row.dutyIdCardBackImg = this.dutyIdCardBackImg;
      row.businessLicense = this.businessLicense;
      editShop(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
